import sp from "../../../assets/images/Footer/sp.svg";

import HomeNewEvent from "./HomeNewEvent";

export default function HomeNew() {
  return (
    <div className="w-full bg-[#F6F7FC] flex flex-col items-center justify-center py-[50px] ">
      <div className="w-full flex flex-col gap-3 items-center justify-center px-[20px] py-[20px] ">
        <div className="w-full flex items-center justify-center gap-1 md:gap-2">
          <img src={sp} alt="bg" className="hidden md:block" />
          <p className="text-[26px] md:text-[32px] text-[#053CC8] font-semibold">
            TIN TỨC & SỰ KIỆN
          </p>
        </div>
      </div>

      <div>
        <HomeNewEvent />
      </div>
    </div>
  );
}
